// DUPLICATED — keep in sync with src/webform/components/Header/Header.tsx (monolith).
// Can't be shared via path alias: a file under src/ resolves react@16/styled-components@5,
// while this workspace needs react@19/styled-components@6. Mirror every change on both
// sides until the monolith webform is decommissioned.
import {useSelector} from "react-redux";

import {brandSelector} from "store/selectors/brandSelector";
import {BrandEnum} from "utils/brand";
import {assertUnreachable} from "utils/assertUnreachable";

import boltLogo from "webform/assets/bolt-logo.svg";
import hoppLogo from "webform/assets/hopp-logo.svg";

import * as Styled from "./header.styled";

const getLogo = (brand?: BrandEnum) => {
    if (!brand) {
        return undefined;
    }
    switch (brand) {
        case BrandEnum.BOLT:
            return boltLogo;
        case BrandEnum.HOPP:
            return hoppLogo;
        default:
            throw assertUnreachable(brand);
    }
};

export const Header = () => {
    const brand = useSelector(brandSelector);
    return (
        <Styled.Background>
            <Styled.Wrapper>
                <Styled.Logo alt="App logo" src={getLogo(brand)} />
            </Styled.Wrapper>
        </Styled.Background>
    );
};
